
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h12v12H0z"}}),_c('path',{attrs:{"fill":"#6D7587","fill-rule":"nonzero","d":"M6.75.75v4.5h4.5v1.5h-4.5v4.5h-1.5v-4.5H.75v-1.5h4.5V.75z"}})])])
          )
        }
      }
    